import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-433f0bd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ccn-cookie-explanation" }

import { ETextSize, EToggleSize } from '../../common/enums/index.enum';
  import CustomToggle from './CustomToggle.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ExplanationParagraph',
  props: {
    active: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    indeterminate: { type: Boolean, default: false },
    size: { default: ETextSize.MD },
    text: null,
    toggle: { type: Boolean, default: false },
    toggleSize: { default: EToggleSize.MD }
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: _normalizeClass(["ccn-cookie-explanation__text", `ccn-cookie-explanation__text--${__props.size}`])
    }, _toDisplayString(__props.text), 3),
    (__props.toggle)
      ? (_openBlock(), _createBlock(CustomToggle, {
          key: 0,
          active: __props.active,
          disabled: __props.disabled,
          indeterminate: __props.indeterminate,
          size: __props.toggleSize,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(`update:active`, $event)))
        }, null, 8, ["active", "disabled", "indeterminate", "size"]))
      : _createCommentVNode("", true)
  ]))
}
}

})